import { render, staticRenderFns } from "./CounselingEventsTeaserBox.vue?vue&type=template&id=2f1c38e2&scoped=true&"
import script from "./CounselingEventsTeaserBox.vue?vue&type=script&lang=js&"
export * from "./CounselingEventsTeaserBox.vue?vue&type=script&lang=js&"
import style0 from "./CounselingEventsTeaserBox.vue?vue&type=style&index=0&id=2f1c38e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1c38e2",
  null
  
)

export default component.exports